import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { Nav } from 'react-bootstrap'
import classnames from 'classnames'
import { Link } from 'raviger'
import { FaSearch } from 'react-icons/fa';
import noLogo from 'images/snapp-icon.png'
import { OrgImage, ProfileIcon, Permission } from 'components'
import { useOrganization } from 'hooks/useOrganization'
import { I18nContext } from 'i18n'
import { INDIVIDUAL_ORGANIZATION } from 'utils/constants'
import { getCurrentUser } from 'utils/getCurrentUser'

function PrivateNavigation({ className, ...props}) {
  const { translate } = useContext(I18nContext);
  const { organization } = getCurrentUser()
  const [showReportDropdown, setShowReportDropdown] = useState(false)

  return (
    <Nav
      className={classnames("h-100", className)}
      {...props}
    >
      <NavItem>
        <Link href="/">{translate('breadcrumbs_home_text')}</Link>
      </NavItem>
      <NavItem>
        <Link href="/member-map">{translate('breadcrumbs_map_text')}</Link>
      </NavItem>
      {organization?.name !== INDIVIDUAL_ORGANIZATION && (
        <>
          <DropdownNavItem 
            onMouseEnter={() => setShowReportDropdown(true)}
            onMouseLeave={() => setShowReportDropdown(false)}
          >
            <DropdownContainer>
              <DropdownToggle>{translate('report_center')}</DropdownToggle>
              {showReportDropdown && (
                <DropdownMenu>
                  <DropdownItem href="/comparison/peer">
                    Comparison Reports
                  </DropdownItem>
                  <DropdownItem href="/reportcenter/landscape">
                    Landscape Reports
                  </DropdownItem>
                </DropdownMenu>
              )}
            </DropdownContainer>
          </DropdownNavItem>
          <Permission permission={['canManageMemberScholarships']}>
            <NavItem className="nav-item__text">
              <Link href="/data-center">{translate('data_center')}</Link>
            </NavItem>
          </Permission>
        </>
      )}
      <NavItem>
        <Link href="/search/advanced/programs">
          <FaSearch size="1.2rem"/>
          {translate('searchProgram')}
        </Link>
      </NavItem>
      <NavItem className="icon-wrapper">
        <ProfileIcon />
      </NavItem>
      <NavItem className="nav-item__icon">
        <Link href="/member-detail">
          <OrgImage
            logo={organization?.logoURL}
            nologo={noLogo}
            orgId={organization?.id}
          />
        </Link>
      </NavItem>
    </Nav>
  )
}

const NavItem = styled(Nav.Item) `
  font-weight: bold;
  max-height: 2.5rem;
  margin: auto 0 auto 1.5rem;
  position: relative;
  
  > a {
    text-transform: uppercase;
    color: ${({ theme }) => theme.palette.primary[0] };
  }
  
  &.nav-item__icon {
    width: 2.5rem
  }
`

const DropdownNavItem = styled(NavItem)`
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    height: 0.5rem;
  }
`

const DropdownContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
`

const DropdownToggle = styled.span`
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.primary[0]};
  cursor: pointer;
`

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
  margin-top: 0.5rem;
`

const DropdownItem = styled(Link)`
  display: block;
  padding: 0.75rem 1rem;
  color: ${({ theme }) => theme.palette.primary[0]};
  text-decoration: none;
  transition: text-decoration 0.2s ease;
  
  &:hover {
    text-decoration: underline;
    text-underline-offset: 6px;
    color: ${({ theme }) => theme.palette.primary[0]};
  }
`

export default PrivateNavigation
